var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a27",
    x1: -481.386,
    y1: -747.701,
    x2: -463.782,
    y2: -778.247,
    gradientTransform: "rotate(60 -897.554 33.597)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#004e8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b27",
    x1: -1395.588,
    y1: 671.239,
    x2: -1374.204,
    y2: 633.738,
    gradientTransform: "rotate(-120 -872.416 -68.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#004685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c27",
    x1: 6.003,
    y1: 14.447,
    x2: 7.447,
    y2: 6.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#50e6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#79eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#99edff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#b0efff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#bef1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3f1ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.243 3.927l4.372 2.515 3.048-1.76A8.792 8.792 0 002.735 2.824a10.019 10.019 0 016.508 1.103z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.558 6.442l-.069 6.034 3.168.851A8.792 8.792 0 0011.415.536a10.442 10.442 0 012.143 5.906z",
    fill: "#0078d4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.552 11.646L9 14.276l.071 3.5a8.8 8.8 0 008.764-8.8 8.432 8.432 0 00-.288-2.09 9.573 9.573 0 01-3.995 4.76z",
    fill: "#5ea0ef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.276l-4.555-2.63-3.02 1.812a8.78 8.78 0 0013.672 1.881A9.908 9.908 0 019 14.276z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.442 11.646l.069-6.237-3.117-.821A8.744 8.744 0 00.2 9a8.847 8.847 0 006.535 8.5 10.191 10.191 0 01-2.293-5.854z",
    fill: "#0078d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 6.3L9 3.757a10.579 10.579 0 00-5.942-1.245A8.758 8.758 0 00.2 9a9.013 9.013 0 00.314 2.32A10.25 10.25 0 014.6 6.3z",
    fill: "#5ea0ef"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3f1ff",
    d: "M13.552 11.646v-5.26L8.997 3.757 4.442 6.386v5.26l4.555 2.63 4.555-2.63z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M9.003 9.071v5.205l-4.561-2.63V6.404l4.561 2.667z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M8.997 9.071v5.205l4.561-2.63V6.404L8.997 9.071z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureMedia);
export default __webpack_public_path__ + "static/media/azure-media.e7cd31e663eb8b9aac8020b88faacd85.svg";
export { ForwardRef as ReactComponent };